import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Email } from '../../../Utils/Global/regularExpressions';
import styles from "./Forms.module.css";
import TextInput from '../UILibrary/TextInput';
import Submission from '../UILibrary/Submission';
import EmailLock from 'Utils/Assets/SVGs/Email';
import { AuthenticationService } from '../../../Logic/Authentication/AuthenticationService';
import { useNavigate } from 'react-router-dom';
import { IForgotPasswordRequestFormData } from '../../../Model/Authentication.model';

const ForgotPassword = () => {

    const auth = new AuthenticationService();
    const { control, handleSubmit, reset } = useForm({
        mode: 'onSubmit',
        defaultValues: { email: '' },
    });

    const navigate = useNavigate();
    const [apiError, setApiError] = useState<string | undefined>(undefined);
    const [apiMessage, setApiMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);


    const onSubmit = async (form: IForgotPasswordRequestFormData) => {
        await auth.handlePasswordResetRequest({
            data: form,
            reset,
            setApiError: (m) => setApiError(m ?? undefined),
            setLoading,
        });
    }

    return (
        <div className={styles.pageWrapper} data-testid="forgot-password-page">
            <div className={styles.forgotContainer} data-testid="forgot-password-container">
                <h2
                    className={`${styles.LoginTitle} ${styles.marginTop10}`}
                    data-testid="forgot-password-title"
                >
                    Reset Your Password
                </h2>

                <div className='margin-top--30' data-testid="email-lock-icon">
                    <EmailLock width={80} height={80} />
                </div>

                <form className={styles.formInnerForget} data-testid="forgot-password-form">
                    <Controller
                        name="email"
                        control={control}
                        rules={{
                            required: { value: true, message: 'Email is required!' },
                            pattern: {
                                value: Email,
                                message: 'Invalid email pattern!',
                            },
                        }}
                        render={({ field, fieldState }) => (
                            <TextInput
                                label="Email"
                                placeholder="Enter your email"
                                type="email-address"
                                value={field.value}
                                onChange={field.onChange}
                                error={fieldState.error?.message}

                            />
                        )}
                    />

                    <Submission
                        data-testid="submission-button"
                        buttonText={loading ? "Sending..." : "Send Code"}
                        onClick={handleSubmit(onSubmit)}
                        disabled={loading}
                        error={apiError}
                    />

                    <div className={styles.redirectLogin} data-testid="redirect-login-section">
                        <span className={styles.navigationText}>Remembered your password?</span>
                        <button
                            type="button"
                            className={styles.navigationLink}
                            data-testid="back-to-login-button"
                            onClick={() => navigate("/auth/login")}

                        >
                            Back to Login
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
